module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Blog","description":"Retrouvez nos articles explorant les nombreux avantages à l\u0027utilisation d\u0027un thermostat connecté.","read-more":"Lire l\u0027article"}}')
  delete Component.options._Ctor
}
